import { OrderDetailModalController } from "../modal/OrderDetailModal/OrderDetailModalController";
import { OrderDeliveryDetailModalController } from "../modal/OrderDeliveryDetailModal/OrderDeliveryDetailModalController";

export default function userOrderDetailModal(modalStore) {
    const modalController = modalStore.methods.getModalController();
    if (modalController.orderDetailModal == null) {
        modalController.setMyorderModal(new OrderDetailModalController())
    }

    return modalController.orderDetailModal
}

export function userOrderDeliveryDetailModal(modalStore) {
    const modalController = modalStore.methods.getModalController();
    if (modalController.orderDeliveryModal == null) {
        modalController.setOrderDeliveryModal(new OrderDeliveryDetailModalController())
    }

    return modalController.orderDeliveryModal
}
